/** @namespace layoutHints */
export default {
  inline: "INLINE",
  small: "SMALL",
  default: "DEFAULT",
  large: "LARGE",
};
